import { render, staticRenderFns } from "./IndexMetrics.vue?vue&type=template&id=504de6f2&scoped=true&"
import script from "./IndexMetrics.vue?vue&type=script&lang=js&"
export * from "./IndexMetrics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504de6f2",
  null
  
)

export default component.exports